import { createAction, createAsyncThunk } from '@reduxjs/toolkit';

import OrdersApi from '../../services/api/OrdersApi';
import { SORT_DIRECTION } from '../../types';
import { RootState } from '../../types';
import { showError } from '../../utils/utils';

const setOrderDetailedLoading = createAction<{
  value: boolean;
  type: 'order' | 'statuses';
}>('order-detailed/setLoading');
const setFilter = createAction<{ value: string; type: 'search' | 'status' }>(
  'order-detailed/setFilter'
);
const setSort = createAction<{
  name: 'positions' | 'sum' | 'count';
  direction: SORT_DIRECTION;
}>('order-detailed/setSort');

const fetchIdOrder = createAsyncThunk(
  'order-detailed/fetchIdOrders',
  async (payload: { id: number }, thunkApi) => {
    try {
      thunkApi.dispatch(
        setOrderDetailedLoading({ value: true, type: 'order' })
      );
      const state = thunkApi.getState() as RootState;
      const response = await OrdersApi.getIdOrder(
        state.auth.account.token,
        payload.id,
        state.auth.account.id
      );
      if (response.status === 200) {
        return response.data;
      }
      return undefined;
    } catch (err) {
      showError(err, thunkApi);
    } finally {
      thunkApi.dispatch(
        setOrderDetailedLoading({ value: false, type: 'order' })
      );
    }
  }
);

const fetchRealizationStatuses = createAsyncThunk(
  'order-detailed/fetchRealizationStatuses',
  async (_, thunkAPI) => {
    try {
      const store = thunkAPI.getState() as RootState;
      thunkAPI.dispatch(
        setOrderDetailedLoading({ value: true, type: 'statuses' })
      );
      const response = await OrdersApi.getOrderRealizationStatuses(
        store.auth.account.token
      );
      if (response.status === 200) {
        return response.data;
      }
      return [];
    } catch (err) {
      showError(err, thunkAPI);
      return [];
    } finally {
      thunkAPI.dispatch(
        setOrderDetailedLoading({ value: false, type: 'statuses' })
      );
    }
  }
);

export {
  fetchIdOrder,
  setOrderDetailedLoading,
  fetchRealizationStatuses,
  setFilter,
  setSort,
};
